import numberUtility from "./NumberUtility"
import { DocumentType} from "../shared/Enums";

const customerHiddenDocumentTypes = [DocumentType.UccFiling, DocumentType.CreditReport, DocumentType.CreditArrangement];

class CategoryUtility{
    categoryNumbers(): number[] {
        return Object.keys(DocumentType)
            .filter(x => numberUtility.isNumber(x))
            .map((i) => Number(i))
            .filter(n => !customerHiddenDocumentTypes.includes(n));
    }
}


const categoryUtility = new CategoryUtility();
export default categoryUtility;